import LegalLayout, { H2, P, UL, PH } from "../LegalLayout";

export default function Versand() {
  return (
    <LegalLayout title="Versandrichtlinien">
      <P>
        Hier findest du alle Informationen zum Versand deiner MAZARO-Bestellung.{" "}
        <strong>Alle konkreten Werte sind Platzhalter und müssen vor Veröffentlichung mit deinen echten Angaben befüllt werden.</strong>
      </P>

      <H2>Versandgebiet</H2>
      <PH>[Z.B. nur Deutschland / Deutschland und EU / weltweit — hier eintragen, was du tatsächlich anbietest.]</PH>

      <H2>Versandkosten</H2>
      <PH>
        [Z.B. 4,95 € pro Bestellung / versandkostenfrei ab 100 € — trage hier deine echte Kostenregelung ein. Die
        Kosten müssen bereits vor der Bestellung angezeigt werden.]
      </PH>

      <H2>Lieferzeit</H2>
      <PH>[Z.B. 2–4 Werktage nach Zahlungseingang — trage deine realistische Bearbeitungs- und Versandzeit ein.]</PH>

      <H2>Versanddienstleister &amp; Tracking</H2>
      <PH>[Z.B. DHL mit Sendungsverfolgung per E-Mail-Link — hier eintragen, falls vorhanden.]</PH>

      <H2>Technischer Hinweis zur Kasse</H2>
      <P>
        Die Zahlung läuft über die Stripe-Kasse. Aktuell sind dort noch keine Versandoptionen hinterlegt — bevor du
        echte Bestellungen entgegennimmst, müssen Versandoptionen in Stripe hinterlegt oder der Versand anderweitig
        abgerechnet werden.
      </P>

      <H2>Teillieferungen &amp; Lieferhindernisse</H2>
      <UL
        items={[
          <PH>[Optional: Regelung zu Teillieferungen und was passiert, wenn Produkte ausverkauft sind.]</PH>,
        ]}
      />
    </LegalLayout>
  );
}
